import { FC } from 'react';
import Icon from '@/components/common/iconedLinks/Icon';

import styles from './Switch.module.scss';
import { useTranslation } from 'next-i18next';
import { URLS } from '@/constants/urls';

type SwitchProps = {
  disabled?: boolean;
  defaultState: boolean;
  onClick: () => void;
  label?: string;
  paragraph?: string;
  customClassName?: string;
}

export const Switch: FC<SwitchProps> = ({
  disabled = false,
  defaultState,
  onClick,
  label,
  paragraph,
  customClassName
}) => {
  const { t } = useTranslation();

  const containerClassNames = [
    styles.container,
    disabled && styles.disabled,
    customClassName
  ].filter(Boolean).join(' ');

  const switchClassNames = [
    !defaultState ? styles.inactive : styles.active,
    disabled && styles.disabled,
  ].filter(Boolean).join(' ');

  const labelClassNames = [
    styles.label,
    disabled && styles.disabled,
  ].filter(Boolean).join(' ');

  const paragraphClassNames = [
    styles.paragraph,
    disabled && styles.disabled,
  ].filter(Boolean).join(' ');

  const renderSwitch = () => (
    <div className={styles.switch}>
      {defaultState && !disabled && (
        <Icon src={URLS.THIN_CHECKMARK_BLACK} alt={t('alter:checkMarkIcon')} />
      )}
    </div>
  );

  const handleClick = () => {
    if (disabled) return;
    onClick();
  };

  return (
    <div className={containerClassNames} onClick={handleClick}>
      <div className={switchClassNames}>
        {renderSwitch()}
      </div>
      {(label || paragraph) && (
        <div className={styles.text}>
          {label && (<span className={labelClassNames}>{label}</span>)}
          {paragraph && (<span className={paragraphClassNames}>{paragraph}</span>)}
        </div>
      )}
    </div>
  );
};

export default Switch;
